export const LOCATIONS_FILTER_TEXT = {
	defaultLabel: 'Location',
	arrivalPlaceholder: 'e.g. New York',
	departurePlaceholder: 'e.g. Boston',
	optionsLabel: 'Lines',
};
